import { render, staticRenderFns } from "./SpareTimeComponent.vue?vue&type=template&id=04435c1c&"
import script from "./SpareTimeComponent.vue?vue&type=script&lang=js&"
export * from "./SpareTimeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports